import React, {useEffect, useState} from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {RouteNames} from "../constants";
import {GetLocalStorage} from "../utils";

function Protected() {
    const isSignedIn = GetLocalStorage('token');
    if (!!isSignedIn) {
      return <Outlet />
    }
    else {
      return <Navigate to={RouteNames.LOGIN} replace />
    }
}

export default Protected